import { api } from '@/api'

/** 书架搜索与全站搜索返回相同结果结构，复用现有列表与分页。 */
export function fetchSearchResult(keyword: string, pageIndex: number, pageSize: number, bookshelf: boolean) {
  return api.get<any, GetContentGetcontentbypassornameResponse>(
    bookshelf ? '/bookshelf/search' : '/content/getContentByPassOrName',
    { params: { ...(bookshelf ? { keyword } : { passOrName: keyword }), pageIndex, pageSize } },
  )
}
